import axios, { getData } from "lib/axios";
import { useQuery } from "react-query";

export const useGetApprovalRoute = () =>
  useQuery("approval-route", async () => {
    const res = await axios.get(`approval-route`).then(getData);
    return Array.isArray(res.data) ? res.data : [];
  });
